import type { AudioRecordingAnswer, AudioRecordingConfiguration } from "@verity/api-client/types";
import i18n from "../../../../../i18n";
import { RecordingPlaybackPlayer } from "../../../../../portal/components/take-assessment/components/RecordingPlaybackPlayer";
import { AnswerStatusChip } from "./shared";
import type { AnswerViewProps } from "./shared";
import styles from "./QuestionAnswer.module.css";

/** Manually graded — no correctness check, just playback. */
export function AudioRecordingAnswerView({ question, response }: AnswerViewProps) {
	const files = (response?.answer as AudioRecordingAnswer | undefined) ?? [];
	const file = files[0];
	if (response?.isAnswered !== true || !file?.fileUrl) {
		return <AnswerStatusChip userText="" isCorrect={null} style={{ margin: "0" }} />;
	}
	const configuration = question.configuration as AudioRecordingConfiguration | null | undefined;
	const recordingMode = configuration?.recordingMode ?? "audio";
	return (
		<div className={styles.audioAnswerWrapper}>
			<RecordingPlaybackPlayer
				fileUrl={file.fileUrl}
				mode={recordingMode}
				audioPosterHint={i18n.t("components.recordingPlaybackPlayerTSX.audioPosterHintReadOnly") as string}
			/>
		</div>
	);
}
